// extracted by mini-css-extract-plugin
export var orderDetails = "_o4-2";
export var orderImage = "_o4-1";
export var orderMeta = "_o4-3";
export var orderSummary = "_o4-0";
export var rightArrow = "_o4-4";